import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['file-preview'],
  queryOptions: {},
};

const previewFile = async (faId, fileId, facId = null) => {
  const url = facId
    ? `/api/framework_agreements/${faId}/suppliers/${facId}/files/${fileId}`
    : `/api/framework_agreements/${faId}/files/${fileId}`;
  const {
    data: { data },
  } = await axios.get(url);

  return data;
};

export const useFilePreview = ({faId, fileId, facId = null, queryParams = {}}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, fileId], () => previewFile(faId, fileId, facId), {
    initialData: { url: '', name: '', file_ext: '', mime_type: '' },
    enabled: !!fileId,
    select: ({ url, name, file_ext: FileExt, mime_type: MimeType }) => ({ url, name, FileExt, MimeType }),
    ...queryOptions,
  });
};
